import { render } from "./PatientChartView.vue?vue&type=template&id=a23e2014&scoped=true"
import script from "./PatientChartView.vue?vue&type=script&lang=js"
export * from "./PatientChartView.vue?vue&type=script&lang=js"

import "./PatientChartView.vue?vue&type=style&index=0&id=a23e2014&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23e2014"]])

export default __exports__